<template>
    <div class="title">{{t('join.createAccount.step8.title')}}</div>
    <!-- Accession Number -->
    <text-block-generic
    :params="{
        label: t('join.createAccount.step8.accessionNumber'),
        content: accessionNumber,
        classes: 'primary'
    }"/>
    <!-- Password -->
    <text-block-generic
    :params="{
        label: t('join.createAccount.step8.passwordLabel'),
        content: t('join.createAccount.step8.passwordContent'),
    }"/>
    <button-link internalClick :label="t('join.createAccount.step8.resendPw')" @clicked="emit('resendPassword')"/>
    <!-- Divider -->
    <divider-generic icon="clock" :title="t('join.createAccount.step8.subtitle')" :applyBorder="false"/>
    <!-- List -->
    <text-block-list :list="[t('join.createAccount.step8.bullet1'), t('join.createAccount.step8.bullet2')]"/>
</template>

<script setup>
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import ButtonLink from '@/components/generic/buttons/Link'
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockList from '@/components/generic/textBlocks/List'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const emit = defineEmits(['resendPassword'])

/** Props
@accessionNumber {Number}
*/
const props = defineProps({
    accessionNumber: Number
})
</script>

<style lang="scss" scoped>
.title {
    margin-bottom: 24px;

    @include H3-Medium;
    color: var(--primary);
}

.wrapper {
    margin-bottom: 16px;
}
</style>
